import React, { useEffect, useState } from "react";
import MatchCard from "../matchCard/MatchCard";
import styles from "./Summary.module.css";
import { fetchGames, fetchTopTeams ,totalGamesBySports} from "../../services/apiEndpoints";
import { API_BASE_URL } from "../../services/apiHandler";
const getImageUri = (imgUrl) => {
  return `${API_BASE_URL}/${imgUrl}`
}
const Summary = () => {

 
  const [cardData, setCardData] = useState([]);
const [topTeams, setTopTeams] = useState([])
const [totalGamesSummary, setTotalGamesSummary] = useState([])


// Fetch Match Card Data 

  const fetchCardData = async () => {
    try {
      const response = await fetchGames();

      console.log("summery response is ", response);

      setCardData(response.data);
    } catch (error) {
      console.log("your error is", error);
    }
  };

  // Fetch Top Team Data 

  const fetchTopTeamsData = async () => {
    try {
      const topTeamResp = await fetchTopTeams();
      console.log("Top Teams Data",topTeamResp.data);
      setTopTeams(topTeamResp.data)
      
    } catch (error) {
      console.log("your error is", error);
      
    }
  }

  // Fetch Total Games Data 

  const fetchTotalGames = async()=>{
    try {
      const TotalGamesResp = await totalGamesBySports();
      console.log("Totl game by sports",TotalGamesResp);
      setTotalGamesSummary(TotalGamesResp?.data)
      
    } catch (error) {
      console.log("your error is", error);
      
    }
  }


  useEffect(() => {
  
 fetchTotalGames()
    fetchCardData();
    fetchTopTeamsData();
    console.log(true)
  }, []);


  // const topTeams = [...teams].sort((a, b) => b.points - a.points).slice(0, 5);

  // const currentDate = new Date();


  // const isDate = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(currentDate);
  // const DateIs= currentDate.toLocaleDateString()
  // console.log("Current Date is",DateIs);

  

  return (
    <div className={styles.mainContainer}>

      {/* match card  */}
      <div className={styles.summaryContainer}>
        <div className={styles.matchList}>
          {cardData &&
            cardData?.map((match, index) => (
              <MatchCard key={index} match={match} />
            ))}

        </div>
      </div>
       

      {/* top 5 Teams  */}

      <div className={styles.topTeams}>
        <h2>Top 5 Teams</h2>
        <ul>
          {topTeams?.map((item, i) => (
            <li key={i}>
              <p className={styles.teamRanking}>{i + 1}</p>

              <div className={styles.teamContainer}>
                <div className={styles.teamLogo}>
                  <img src={getImageUri(item?.team_img)} alt={item?.team_name} />
                </div>
                <span className={styles.teamName}>{item?.team_name}</span>
              </div>

              <span className={styles.teamPoints}>{item?.points}</span>
            </li>
          ))}
        </ul>
      </div>


      {/* Games Summary  */}
      <div className={styles.games}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th colSpan="100%">Game Summary</th>
            </tr>
            <tr>
              <th>Games</th>
              <th>Total</th>
              <th>Remaining</th>
              <th>Completed</th>
            </tr>
          </thead>
          <tbody>
            {totalGamesSummary.map((game,index) => (
              <tr key={index}>
                <td className={styles.gameName}>{game?.sport_name}</td>
                <td>{game?.total_games}</td>
                <td>{game?.remaining_games}</td>
                <td>{game?.game_completed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Summary;
